module.exports = __webpack_public_path__ + "img/template.75adaead.jpg";